import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';

var GroupFilter = /*#__PURE__*/function (_Component) {
  _inherits(GroupFilter, _Component);

  var _super = _createSuper(GroupFilter);

  function GroupFilter(props) {
    var _this;

    _classCallCheck(this, GroupFilter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      _this.setState({
        value: '0'
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange('0');
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      if (_this.props.onChange) {
        _this.props.onChange(event.target.value);
      }

      _this.setState({
        value: event.target.value
      });
    });

    _this.state = {
      value: props.selectedGroupId
    };
    return _this;
  }

  _createClass(GroupFilter, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, this.props.translate('section')), /*#__PURE__*/React.createElement("select", {
        value: this.state.value,
        onChange: this.onChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, this.props.translate('select-an-alternative')), this.props.sections != null ? this.props.sections.map(function (group) {
        return /*#__PURE__*/React.createElement("option", {
          key: "gfilter-section-".concat(group.id),
          value: group.id
        }, group.title);
      }) : null), this.state.value != '0' ? /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: '0.25em',
          cursor: 'pointer'
        },
        onClick: this.reset
      }, this.props.translate('restore-filter')) : null)));
    }
  }]);

  return GroupFilter;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(GroupFilter);